import fetch from '@giro/shared-utils/fetch.util';

export default async function postApiPaymentLinksService(body: any) {
  return fetch('payment-links', {
    method: 'POST',
    ms: 'PDV',
    auth: true,
    body: JSON.stringify(body),
  });
}
